export default __webpack_public_path__ + "images/CX.af8e22f.png";